import { render, staticRenderFns } from "./MicrosoftCallback.vue?vue&type=template&id=2cb77be7&scoped=true"
import script from "./MicrosoftCallback.vue?vue&type=script&lang=js"
export * from "./MicrosoftCallback.vue?vue&type=script&lang=js"
import style0 from "./MicrosoftCallback.vue?vue&type=style&index=0&id=2cb77be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb77be7",
  null
  
)

export default component.exports